module.exports = __webpack_public_path__ + "7ff5cf58d35e6b11e55b7c5a51b4a988.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/logo/horizontal-white-team.png
// module id = ./app/img/logo/horizontal-white-team.png
// module chunks = 10